export const capitalizer = (word: string) =>
  word[0].toUpperCase() + word.slice(1)
